<div class="sidebar-panel">
    <div id="scroll-area"
         [perfectScrollbar]
         class="navigation-hold"
         fxLayout="column">
        <div class="sidebar-hold">

            <!-- App Logo -->
            <div class="branding">
                <img src="assets/bbraun/logo/bbrun-logo-white.svg"
                     alt=""
                     *ngIf="!layoutConf.sidebarCompactToggle"
                     class="app-logo">
                <img src="assets/bbraun/logo/menu-icon.png"
                     alt=""
                     *ngIf="layoutConf.sidebarCompactToggle"
                     class="app-logo">
            </div>
            <!-- Navigation -->
            <app-sidenav [items]="menuItems"
                         [hasIconMenu]="hasIconTypeMenuItem"
                         [iconMenuTitle]="iconTypeMenuTitle"></app-sidenav>
        </div>
    </div>
</div>